// extracted by mini-css-extract-plugin
module.exports = {"card":"cityCard_card__1g5ZO","icon":"cityCard_icon__LtE-i","name":"cityCard_name__yOuVp"};